<div
  class="pt-5 bg-surface-magic dark:bg-surface-magic-darkmode rounded-lg shadow-[0px_1px_1px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-outline dark:outline-outline-darkmode flex-1"
>
  <div class="flex flex-col md:flex-row gap-3 px-6 mb-5">
    <div class="flex-1 grid grid-cols-4 md:flex gap-3">
      <ui-button
        [mode]="filter().granularity === 'YEAR' ? 'filled' : 'outlined'"
        (click)="changeGranularity.emit('YEAR')"
        size="small"
        class="flex-none"
        expand="full"
        data-track="consumption-granularity-year"
      >
        {{ 'cockpit.analysis.consumption.graph.granularityYear' | transloco }}
      </ui-button>
      <ui-button
        [mode]="filter().granularity === 'MONTH' ? 'filled' : 'outlined'"
        (click)="changeGranularity.emit('MONTH')"
        size="small"
        class="flex-none"
        expand="full"
        data-track="consumption-granularity-month"
      >
        {{ 'cockpit.analysis.consumption.graph.granularityMonth' | transloco }}
      </ui-button>
      <ui-button
        [mode]="filter().granularity === 'WEEK' ? 'filled' : 'outlined'"
        (click)="changeGranularity.emit('WEEK')"
        size="small"
        class="flex-none"
        expand="full"
        data-track="consumption-granularity-week"
      >
        {{ 'cockpit.analysis.consumption.graph.granularityWeek' | transloco }}
      </ui-button>
      <ui-button
        [mode]="filter().granularity === 'DAY' ? 'filled' : 'outlined'"
        (click)="changeGranularity.emit('DAY')"
        size="small"
        class="flex-none"
        expand="full"
        data-track="consumption-granularity-day"
      >
        {{ 'cockpit.analysis.consumption.graph.granularityDay' | transloco }}
      </ui-button>
    </div>
    <ui-button
      mode="outlined"
      size="small"
      class="flex-none hidden md:block"
      (click)="onClickTodayButton()"
      data-track="consumption-date-today-button"
    >
      {{ 'cockpit.analysis.consumption.graph.today' | transloco }}
    </ui-button>
    <div class="flex-none w-full md:w-[244px] flex gap-2">
      <ui-button
        mode="outlined"
        size="small"
        [iconOnly]="true"
        (click)="onClickPreviousButton()"
        class="flex-none"
        data-track="consumption-date-prev-button"
      >
        <ng-icon name="heroChevronLeft" size="20" class="!block" />
      </ui-button>
      <div
        class="flex-1 flex items-center justify-center text-sm"
        data-track="consumption-date-display"
      >
        @switch (filter().granularity) {
          @case ('YEAR') {
            {{ filter().date | date: 'yyyy' }}
          }
          @case ('MONTH') {
            {{ filter().date | date: 'MMMM yyyy' }}
          }
          @case ('WEEK') {
            {{ selectedFrom() | date: 'dd.MM.' }} -
            {{ selectedTo() | date: 'dd.MM.yyyy' }}
          }
          @case ('DAY') {
            {{ filter().date | date: 'dd.MM.yyyy' }}
          }
        }
      </div>
      <ui-button
        mode="outlined"
        size="small"
        [iconOnly]="true"
        (click)="onClickNextButton()"
        class="flex-none"
        data-track="consumption-date-next-button"
      >
        <ng-icon name="heroChevronRight" size="20" class="!block" />
      </ui-button>
    </div>
  </div>

  @let loadCurve = state();
  @if (!loadCurve || loadCurve.isLoading) {
    <div
      class="w-full h-120 flex items-center justify-center text-primary dark:text-primary-darkmode"
    >
      @if (loadCurve?.isLoading) {
        <ui-loading-spinner size="24" />
      }
    </div>
  } @else if (loadCurve.error) {
    <app-error-component
      [enableRetry]="true"
      (clickRetry)="clickReload.emit()"
      class="block h-120 w-full"
    />
  } @else {
    @if (loadCurve.data; as data) {
      @if (view() === 'table') {
        <div class="px-6 py-5">
          <table class="w-full">
            <thead>
              <tr class="border-b border-outline dark:border-outline-darkmode">
                <th class="text-start min-h-14 p-3">
                  {{ 'cockpit.analysis.consumption.graph.tableHeaderValidFrom' | transloco }}
                </th>
                <th class="text-end min-h-14 p-3">
                  {{ 'cockpit.analysis.consumption.graph.tableHeaderUsage' | transloco }}
                </th>
              </tr>
            </thead>
            <tbody>
              @for (item of data.data; track $index) {
                <tr class="border-b border-outline dark:border-outline-darkmode">
                  <td class="min-h-14 p-3 leading-6 text-sm">
                    @switch (filter().granularity) {
                      @case ('YEAR')
                      @case ('MONTH') {
                        {{ item.validFrom | date: 'dd.MM.yyyy' }}
                      }
                      @case ('WEEK')
                      @case ('DAY') {
                        {{ item.validFrom | date: 'dd.MM.yyyy HH:mm' }}
                      }
                    }
                  </td>
                  <td class="text-end min-h-14 p-3 leading-6 text-sm">
                    {{ item.usageInKWh | germanNumber }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <ui-chart
          [options]="data.data | analysisConsumptionChartOptions: graphOptions()"
          theme="stromify-dark"
          class="hidden dark:block h-120 w-full"
        />
        <ui-chart
          [options]="data.data | analysisConsumptionChartOptions: graphOptions()"
          theme="stromify-light"
          class="dark:hidden h-120 w-full"
        />
      }

      @if (showPlaceholder()) {
        <div class="py-5 px-6">
          <ui-alert color="primary">
            <ng-icon slot="icon" name="heroInformationCircle" size="20" class="!block" />
            <h3 slot="title">
              {{ 'cockpit.analysis.consumption.graph.slpAlertTitle' | transloco }}
            </h3>
            <p>
              {{ 'cockpit.analysis.consumption.graph.slpAlertDescription' | transloco }}
            </p>
            <ui-button
              mode="outlined"
              size="small"
              class="block mt-4"
              [routerLink]="['/organizations', organizationId(), 'energy-interfaces']"
            >
              <span class="text-primary dark:text-primary-darkmode">
                {{ 'cockpit.analysis.consumption.graph.slpAlertButton' | transloco }}
              </span>
            </ui-button>
          </ui-alert>
        </div>
      }
    }
  }
</div>
